import * as JWT from './jwt'
import * as SignIn from './signIn'

export default { ...JWT, ...SignIn }
